import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgJumia = function SvgJumia(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M19.317 6.737a6.531 6.531 0 1 0-.002 13.062 6.531 6.531 0 0 0 .002-13.062Zm2.691 10.49-2.691-1.414-2.694 1.414.515-2.997-2.177-2.122 3.01-.438 1.346-2.728 1.345 2.728 3.01.438-2.179 2.122.515 2.997Z",
      fill: "currentColor"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.222 19.761a1 1 0 0 1 .233 1.396l-5.488 7.688a1 1 0 0 1-1.628-1.162l5.488-7.689a1 1 0 0 1 1.395-.233ZM18.736 21.432a1 1 0 0 1 .188 1.402l-2.773 3.63a1 1 0 0 1-1.59-1.215l2.773-3.63a1 1 0 0 1 1.402-.187ZM12.583 17.256a1 1 0 0 1 .187 1.402l-2.715 3.554a1 1 0 0 1-1.59-1.215l2.716-3.553a1 1 0 0 1 1.402-.188Z",
      fill: "currentColor"
    }))]
  }));
};
export default SvgJumia;